import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { PrimaryIconButton } from '../../theme/index';
import PrintIcon from '@mui/icons-material/Print';
import moment from 'moment';
import 'moment/locale/es';

function createData(status, openDate, openMount, closeDate, closeMount, user) {
  return { status, openDate, openMount, closeDate, closeMount, user };
}

const rows = [
  createData( false, moment().format('DD/MM/YYYY'), 80, moment().format('DD/MM/YYYY'), 80, 'admin' ),
];


const CashClose = () => {
  return (
    <>
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Estado de caja</TableCell>
                    <TableCell>Fecha apertura</TableCell>
                    <TableCell>Monto apertura</TableCell>
                    <TableCell>Fecha cierre</TableCell>
                    <TableCell>Monto cierre</TableCell>
                    <TableCell>Responsable</TableCell>
                    <TableCell>Imprimir</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {rows.map((row) => (
                    <TableRow
                    key={row.code}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    <TableCell component="th" scope="row">{
                        (row.status) ? 'Abierta' : 'Cerrada'
                    }</TableCell>
                    <TableCell>{row.openDate}</TableCell>
                    <TableCell>${row.openMount}</TableCell>
                    <TableCell>{row.closeDate}</TableCell>
                    <TableCell>${row.closeMount}</TableCell>
                    <TableCell>{row.user}</TableCell>
                    <TableCell>
                        <PrimaryIconButton aria-label="delete" sx={{ mx: '.4rem' }}>
                            <PrintIcon />
                        </PrimaryIconButton>
                    </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
    </>
  )
}

export default CashClose